import { render, staticRenderFns } from "./OldFenex.vue?vue&type=template&id=2819e96d&scoped=true&"
import script from "./OldFenex.vue?vue&type=script&lang=js&"
export * from "./OldFenex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2819e96d",
  null
  
)

export default component.exports